<template>
    <div v-loading='loading'>
        <p style="color:red;font-size:35px">操作记录</p>
        <div v-for="(i,index) in Data" :key="index">
            {{i.time}} &nbsp&nbsp&nbsp {{i.person}} &nbsp&nbsp&nbsp {{i.event}}
        </div>
    </div>
</template>

<script>
import {cxcz} from "../../api/api"
    export default {
        data() {
            return {
               Data:[],
               loading:true
            }
        },
        created () {
            var un = window.localStorage.getItem('un');
            if(un == '' || un == null || un == undefined){
                this.loading = true;
                return false;
            }
            cxcz().then(res => {
                // console.log(res);
                this.Data = res;
                this.loading = false;
            })
        },
    }
</script>

<style lang="scss" scoped>

</style>